// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.featured-modal {
  width: 60vw !important;
}
.featured-product-header {
  color: #000;
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 2.75rem;
}
.featured-modal .product-title {
  color: #d2042d;
  font-size: 1.1875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.featured-campaigns-table {
  height: 50vh;
  overflow-y: scroll;
}

.featured-campaigns-table .ant-table-thead > tr > th {
  text-align: left !important;
}
.navigate-campaign {
  color: var(--Colors-Primary-500, #d2042d);
  text-align: right;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

@media (max-width: 767px) {
  .mobile-featured-drawer {
    border-radius: 0;
    height: 100vh !important;
  }
  .mobile-featured-drawer .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .mobile-featured-content {
    margin-left: 18px;
  }
  .mobile-featured-title {
    font-size: 19px;
    font-weight: 700;
    margin-top: 26px;
  }
  .mobile-featured-drawer .product-title {
    font-size: 16px;
    font-weight: 500;
    color: #d2042d;
    margin-bottom: 12px;
  }
  .campaign-list {
    font-weight: 400;
    font-size: 16px;
  }
  .featured-campaigns-mobile-card {
    margin: 12px 18px 16px 18px;
    box-shadow: 2px 2px 30px 0px rgba(0, 0, 0, 0.05);
  }
  .featured-campaigns-mobile-card .ant-card-body {
    padding: 12px;
  }
  .featured-label {
    color: #8e9190;
    font-weight: 400;
    font-size: 13px;
  }
  .featured-value {
    font-weight: 500;
    font-size: 15px;
    color: #000;
  }
  .featured-campaigns-mobile-card .view-campaign {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/modals/featured-campaigns/FeaturedCampaignsModal.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,gDAAgD;EAClD;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".featured-modal {\n  width: 60vw !important;\n}\n.featured-product-header {\n  color: #000;\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  margin-top: 2.75rem;\n}\n.featured-modal .product-title {\n  color: #d2042d;\n  font-size: 1.1875rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.featured-campaigns-table {\n  height: 50vh;\n  overflow-y: scroll;\n}\n\n.featured-campaigns-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n.navigate-campaign {\n  color: var(--Colors-Primary-500, #d2042d);\n  text-align: right;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n\n@media (max-width: 767px) {\n  .mobile-featured-drawer {\n    border-radius: 0;\n    height: 100vh !important;\n  }\n  .mobile-featured-drawer .ant-drawer-header-title {\n    flex-direction: row-reverse;\n  }\n  .mobile-featured-content {\n    margin-left: 18px;\n  }\n  .mobile-featured-title {\n    font-size: 19px;\n    font-weight: 700;\n    margin-top: 26px;\n  }\n  .mobile-featured-drawer .product-title {\n    font-size: 16px;\n    font-weight: 500;\n    color: #d2042d;\n    margin-bottom: 12px;\n  }\n  .campaign-list {\n    font-weight: 400;\n    font-size: 16px;\n  }\n  .featured-campaigns-mobile-card {\n    margin: 12px 18px 16px 18px;\n    box-shadow: 2px 2px 30px 0px rgba(0, 0, 0, 0.05);\n  }\n  .featured-campaigns-mobile-card .ant-card-body {\n    padding: 12px;\n  }\n  .featured-label {\n    color: #8e9190;\n    font-weight: 400;\n    font-size: 13px;\n  }\n  .featured-value {\n    font-weight: 500;\n    font-size: 15px;\n    color: #000;\n  }\n  .featured-campaigns-mobile-card .view-campaign {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
